import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";
import { BatchSubProductsDialogProps } from "../components/BatchSubProductsDialog";

export type SubProductsDialogContextType = {
  closeDialog: () => void;
  openDialog: (props: BatchSubProductsDialogProps) => void;
};

export const SubProductsDialogContext =
  createContext<SubProductsDialogContextType>(createDefaultContext());
